import { useAmplitude } from './amplitude/useAmplitude';
export { useAmplitude };
